var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-text-field',{ref:"amount",attrs:{"label":_vm.label,"prefix":"$","value":_vm.amount,"rules":[_vm.rule_amount]},on:{"input":_vm.onChangeAmount}})],1),_c('v-col',{staticStyle:{"max-width":"120px"}},[_c('v-select',{attrs:{"items":_vm.items,"value":_vm.currency_code},on:{"change":_vm.onChangeCurrency}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }